/// <reference path="../../../state/userStats/types.js" />
import { useState, useCallback } from "react";

/**
 * @param {{ user?: User|undefined, positives: number, negatives: number, description: string }} initialValues
 */
export function useFormUser(
  initialValues = {
    user: undefined,
    positives: 0,
    negatives: 0,
    description: "",
  }
) {
  const [user, setUser] = useState(initialValues.user);
  const [positives, setPositives] = useState(initialValues.positives);
  const [negatives, setNegatives] = useState(initialValues.negatives);
  const [description, setDescription] = useState(initialValues.description);

  const handleUpdateFormValues = useCallback(
    ({ user, positives, negatives, description }) => {
      setUser(user);
      setDescription(description);
      setPositives(positives);
      setNegatives(negatives);
    },
    [setUser, setDescription, setPositives, setNegatives]
  );

  const handleChangeUserId = useCallback((value) => setUser(value), []);
  const handleChangeDescription = useCallback(
    (e) => setDescription(e.target.value),
    []
  );

  const handleChangePositives = useCallback((value) => setPositives(value), []);
  const handleChangeNegatives = useCallback((value) => setNegatives(value), []);
  const handleClearForm = useCallback(() => {}, []);

  const formUser = {
    user: {
      value: user,
      onChange: handleChangeUserId,
    },
    positives: {
      value: positives,
      onChange: handleChangePositives,
    },
    negatives: {
      value: negatives,
      onChange: handleChangeNegatives,
    },
    description: {
      value: description,
      onChange: handleChangeDescription,
    },
  };

  return {
    formUser,
    description,
    handleUpdateFormValues,
    handleClearForm,
  };
}
